"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrganizationalBodiesGrid() {
  const headerReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const bodies = [{
    index: "01",
    name: "Majelis Pimpinan Nasional",
    style: "KEBIJAKAN STRATEGIS",
    bio: "Pusat komando tertinggi yang merumuskan arah kebijakan organisasi dan menjaga marwah konstitusi di tingkat nasional.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/mpn_leadership.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/mpn_leadership.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/mpn_leadership.png-wvc-sizes"
    },
    size: "large"
  }, {
    index: "02",
    name: "Badan Pengusaha",
    style: "EKONOMI & BISNIS",
    bio: "Menggerakkan roda ekonomi organisasi melalui unit-unit usaha mandiri yang profesional dan berdaya saing tinggi.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/business_unit.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/business_unit.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/business_unit.png-wvc-sizes"
    },
    size: "small"
  }, {
    index: "03",
    name: "Lembaga Hukum",
    style: "ADVOKASI & HUKUM",
    bio: "Memberikan perlindungan hukum dan pendampingan bagi anggota serta masyarakat yang membutuhkan keadilan.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/legal_advocacy.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/legal_advocacy.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/legal_advocacy.png-wvc-sizes"
    },
    size: "equal"
  }, {
    index: "04",
    name: "Satuan Mahasiswa",
    style: "KADERISASI & AKADEMIS",
    bio: "Wadah pengembangan intelektual bagi generasi muda untuk menjadi pemimpin masa depan yang berkarakter.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/student_corps.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/student_corps.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/student_corps.png-wvc-sizes"
    },
    size: "equal"
  }, {
    index: "05",
    name: "Srikandi",
    style: "PEMBERDAYAAN PEREMPUAN",
    bio: "Menggerakkan peran aktif perempuan dalam pembangunan sosial, ekonomi, dan kemanusiaan di seluruh pelosok negeri.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/srikandi_unit.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/srikandi_unit.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/srikandi_unit.png-wvc-sizes"
    },
    size: "equal"
  }, {
    index: "06",
    name: "KOTI Mahatidana",
    style: "OPERASIONAL & KOMANDO",
    bio: "Garda terdepan dalam aksi kemanusiaan, pengamanan, dan tanggap darurat bencana di seluruh wilayah Indonesia.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/koti_command.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/koti_command.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/koti_command.png-wvc-sizes"
    },
    size: "feature"
  }];
  return <section data-section-id="103" id="organizationalbodiesgrid" className="bg-white text-black py-24 md:py-40 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div ref={headerReveal.ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 mb-16 md:mb-24 transition-all duration-1000 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="font-sans text-xs md:text-sm uppercase tracking-widest text-gray-500 mb-8">
              02 / Struktur Organisasi
            </p>
            <h2 className="font-default font-bold text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
              <span className="block text-orange-600 italic font-light">Badan</span>
              <span className="block">Lembaga</span>
              <span className="block italic font-light">Sayap.</span>
            </h2>
          </div>

          <div className="flex flex-col justify-end">
            <p className="font-default text-base md:text-lg leading-relaxed text-gray-700 max-w-[60ch] mb-8">
              ABADI.NEWS menyajikan informasi mendalam mengenai struktur organisasi yang solid. Setiap badan dan lembaga sayap bekerja secara sinergis untuk menjalankan mandat organisasi, memberikan pelayanan terbaik bagi masyarakat, dan menjaga integritas bangsa melalui aksi nyata di lapangan.
            </p>
            <Link to="/AgencyInstitutionWingPage" className="group inline-flex items-center gap-3 font-sans text-xs md:text-sm uppercase tracking-widest text-black hover:text-orange-600 transition-colors duration-300 w-fit border-b border-gray-300 hover:border-orange-600 pb-2">
              Lihat Semua Badan
              <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {}
        <div ref={gridReveal.ref} className="space-y-6 md:space-y-8">
          {}
          <div data-index={0} className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 transition-all duration-1000 delay-100 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="md:col-span-8">
              <BodyCard body={bodies[0]} dataIndex={0} />
            </div>
            <div className="md:col-span-4">
              <BodyCard body={bodies[1]} dataIndex={1} />
            </div>
          </div>

          {}
          <div data-index={1} className={`grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 transition-all duration-1000 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <BodyCard body={bodies[2]} dataIndex={2} />
            <BodyCard body={bodies[3]} dataIndex={3} />
            <BodyCard body={bodies[4]} dataIndex={4} />
          </div>

          {}
          <div data-index={2} className={`transition-all duration-1000 delay-300 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <BodyCard body={bodies[5]} dataIndex={5} featured />
          </div>
        </div>
      </div>
    </section>;
}
function BodyCard({
  body,
  dataIndex,
  featured = false
}: {
  body: {
    index: string;
    name: string;
    style: string;
    bio: string;
    image: {
      src: string;
      srcset: string;
      sizes: string;
    };
  };
  dataIndex: number;
  featured?: boolean;
}) {
  return <div data-index={dataIndex} className="group relative w-full [perspective:1200px]">
      <div className={`relative w-full ${featured ? "aspect-[16/10] md:aspect-[21/9]" : "aspect-[3/4]"} [transform-style:preserve-3d] transition-transform duration-[600ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:[transform:rotateY(180deg)]`}>
        {}
        <div className="absolute inset-0 [backface-visibility:hidden] overflow-hidden border border-gray-200 group-hover:border-orange-600 transition-colors duration-300 rounded-lg">
          <img src={body.image.src} data-wvc-srcset={body.image.srcset} data-wvc-sizes={body.image.sizes} alt={body.name} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale contrast-110" />
          {}
          <div className="absolute inset-0 opacity-30 mix-blend-overlay pointer-events-none" style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E\")"
        }} />
          {}
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/90 via-black/40 to-transparent pointer-events-none" />

          {}
          <div className="absolute bottom-0 left-0 p-5 md:p-7">
            <p className="font-sans text-xs uppercase tracking-widest text-gray-300 mb-2">
              {body.index}
            </p>
            <h3 className="font-default font-bold text-xl md:text-2xl uppercase tracking-wider text-white">
              {body.name}
            </h3>
          </div>
        </div>

        {}
        <div className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] bg-orange-50 border border-orange-600 p-6 md:p-8 flex flex-col justify-between rounded-lg">
          <div>
            <p className="font-sans text-xs uppercase tracking-widest text-gray-600 mb-4">
              {body.index} / Fokus Utama
            </p>
            <p className="font-default font-bold text-lg md:text-2xl uppercase tracking-wider text-black mb-6">
              {body.style}
            </p>
            <p className="font-default text-sm md:text-base leading-relaxed text-gray-800 line-clamp-3">
              {body.bio}
            </p>
          </div>

          <div className="flex items-end justify-between mt-6">
            <p className="font-default font-bold text-base uppercase tracking-wider text-black">
              {body.name}
            </p>
            <Link to="/AgencyInstitutionWingPage" className="group/link inline-flex items-center gap-2 font-sans text-xs uppercase tracking-widest text-orange-700 hover:text-orange-800 transition-colors border-b border-orange-600/40 hover:border-orange-600 pb-1">
              Selengkapnya
              <ArrowRight className="size-3.5 transition-transform duration-300 group-hover/link:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
}